import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Settings, LogOut, ChevronDown, User } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Sidebar } from './Sidebar';
// import { feedbackApi } from '../../services/api';

// const BADGE_REFRESH_MS = 60_000;

const AdminLayout: React.FC = () => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);
  // const [badgeCounts, setBadgeCounts] = useState<Record<string, number>>({});

  const navigate = useNavigate();
  const { user, logout, isAdmin, selfImprovementEnabled } = useAuth();

  // Close user menu on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target as Node)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // useEffect(() => {
  //   const fetchCounts = async () => {
  //     try {
  //       const resp = await feedbackApi.getBadgeCounts();
  //       const { feedbackOpen, callbackOpen } = (resp.data as any).data ?? {};
  //       setBadgeCounts({
  //         ...(feedbackOpen > 0 ? { '/admin/feedback': feedbackOpen } : {}),
  //         ...(callbackOpen > 0 ? { '/admin/callback-requests': callbackOpen } : {}),
  //       });
  //     } catch {
  //       // ignore — badge counts are best-effort
  //     }
  //   };
  //   fetchCounts();
  //   const interval = setInterval(fetchCounts, BADGE_REFRESH_MS);
  //   return () => clearInterval(interval);
  // }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const displayName = user?.name || user?.email || 'User';
  const initials = displayName.charAt(0).toUpperCase();

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar isAdmin={isAdmin} selfImprovementEnabled={selfImprovementEnabled} />

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <header className="h-16 border-b border-border bg-white flex items-center justify-between px-6 flex-shrink-0 z-10">
          <h1 className="text-lg font-semibold text-foreground">Knowledge Companion Dashboard</h1>

          {/* User menu */}
          <div className="relative" ref={userMenuRef}>
            <button
              onClick={() => setUserMenuOpen((v) => !v)}
              className="flex items-center gap-2 p-1.5 pr-3 hover:bg-accent rounded-lg transition-colors"
            >
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                <span className="text-white text-sm font-medium">{initials}</span>
              </div>
              <span className="text-sm font-medium text-foreground">{displayName}</span>
              {isAdmin && (
                <span className="text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded font-medium">
                  Admin
                </span>
              )}
              <ChevronDown className="w-4 h-4 text-muted-foreground" />
            </button>

            {userMenuOpen && (
              <div className="absolute right-0 mt-1 w-48 bg-white border border-border rounded-lg shadow-lg py-1 z-50">
                <button
                  onClick={() => {
                    setUserMenuOpen(false);
                    navigate('/admin/settings');
                  }}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-foreground hover:bg-accent transition-colors"
                >
                  <Settings className="w-4 h-4 text-muted-foreground" />
                  Settings
                </button>
                <div className="h-px bg-border my-1" />
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-destructive hover:bg-accent transition-colors"
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </button>
              </div>
            )}
          </div>
        </header>

        {/* Main content */}
        <main className="flex-1 overflow-y-auto p-6 bg-[#f9fafb]">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
